import React, { Component, PropTypes } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import _ from 'lodash';

import './translationsListWithEditor.scss';

import projectsStore from 'storeState/projects';
import translationsStore from 'storeState/translations';
import generalStore from 'storeState/general';
import uiStore from 'storeState/ui';
import authStore from 'storeState/auth';

import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import ATable from "views/aTable/ATable";
import FormButtons from 'views/formButtons/FormButtons';
import Button from 'views/button/Button';

import FaUpload from "react-icons/lib/fa/upload";

import {formatDateTime} from 'service/LocaleService';
import TitleWithIconBar from "views/titleWithIconBar/TitleWithIconBar";
import IconBarItem from "views/titleWithIconBar/IconBarItem";
import URLService from "../../../service/URLService";
import FaDownload from "react-icons/lib/fa/download";
import Loading from "views/loading/Loading";

import {actionMeta as translationsActionMeta} from 'storeState/translations/meta';
import Select from "../select/Select";

const translationsAPI = translationsActionMeta.urlBuilders;

const EXPORT_FORMATS = ['json', 'js', 'po', 'xlf'];
const EXPORT_FORMAT_VALUES = _.map(EXPORT_FORMATS, (ef) => {
    return {
        value: ef,
        label: ef,
    }
})

export class TranslationsListWithEditor extends Component {

    static contextTypes = {
        intl: PropTypes.object
    }

    constructor(props){
        super(props)
        this.state = {
            exportFormat: EXPORT_FORMATS[0],
        }
    }

    componentDidMount() {
        this.project = this.props.project;
        this.locale = this.props.locale;
        this.loadVariables({loadInBackground: false});

        this.pullChanges = setInterval(() => {
            this.loadVariables({loadInBackground: true});
        }, 5000);
    }

    componentWillUnmount() {
        if(this.pullChanges) {
            clearInterval(this.pullChanges);
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if(!_.isEqual(this.project, nextProps.project) || !_.isEqual(this.locale, nextProps.locale)) {
            this.project = nextProps.project;
            this.locale = nextProps.locale;
            this.loadVariables({loadInBackground: true});
        }
    }

    isInViewport(element, offset = 0) {
        if (!element) return false;
        const top = element.getBoundingClientRect().top;
        return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!_.isEqual(prevProps.translations, this.props.translations) && this.selectedItem && !this.isInViewport(this.selectedItem)){
            this.selectedItem.scrollIntoView({
                behavior: 'auto',
                block: 'start',
            })
            this.scrollItem.scrollTop -= 30;
        }
    }

    loadVariables = ({loadInBackground}) => {
        if(this.project && this.locale) {
            setTimeout(() => {
                this.props.actions.translationsListRequest({
                    project_id: this.project.id,
                    string_id: this.locale.project_locale_string_id,
                    loadInBackground: loadInBackground
                });
            });
        }
    }

    getTitle() {
        if(!this.props.project || !this.props.locale) {
            return "";
        }

        const {formatMessage} = this.context.intl;

        const t = (
            formatMessage({
                id: "translationsList.title",
                defaultMessage: "Project: {project}",
            }, {
                project: this.props.project.name,
                //locale: this.props.locale.display_name,
            })
        );
        return t;
    }

    handleUploadDefaultMessagesClick = () => {
        this.el_upload_default_messages.click();
    }

    handleUploadLocaleMessagesClick = () => {
        this.el_upload_locale_messages.click();
    }

    handleUploadDefaultMessagesFileSelected = () => {
        if(this.el_upload_default_messages.files.length>0) {
            const file = this.el_upload_default_messages.files[0];

            console.log("filesize", file.size);

            try {
                this.props.actions.translationsUploadDefaultMessagesRequest({
                    file: file,
                    project_id: this.project.id,
                    string_id: this.locale.project_locale_string_id
                });
                this.props.actions.flashInfo("Uploading...");
            } catch(e) {
                this.props.actions.flashError("Upload failed");
                console.log(e);
            }
        }
    }

    handleUploadLocaleMessagesFileSelected = () => {
        if(this.el_upload_locale_messages.files.length>0) {
            const file = this.el_upload_locale_messages.files[0];
            console.log("filesize", file.size);

            try {
                this.props.actions.translationsUploadLocaleMessagesRequest({
                  file: file,
                  project_id: this.project.id,
                  string_id: this.locale.project_locale_string_id
                });
                this.props.actions.flashInfo("Uploading...");
            } catch(e) {
                this.props.actions.flashError("Upload failed");
                console.log(e);
            }
        }
    }

    getSelectedVariableName = () => {
        return URLService.getQueryParameterAsString("variable", null);
    }

    handleVariableClick = (variable_name) => {
        URLService.setQueryParameter("variable", variable_name);
        this.setState({})

        const variables = this.getVariables();
        const selectedVariable = _.find(variables, (v)=>v.variable_name == variable_name);

        if(this.el_target_textarea) {
            this.el_target_textarea.value = selectedVariable.text;
        }
    }

    getVariables = () => {
        const {locale, project} = this.props;

        const key = (project && locale) ? project.id + "_" + locale.project_locale_string_id : null;
        const variables = key ? (this.props.translations[key] || []) : [];
        return variables;
    }

    handleEditorTargetChange = (ev) => {
        const variables = this.getVariables();
        const variable_name = this.getSelectedVariableName();
        const selectedVariable = _.find(variables, (v)=>v.variable_name == variable_name);
        selectedVariable.text = ev.target.value;
        this.setState({})

        this.scrollingInizialized = false;
        this.props.actions.translationsUpdateRequest({
            text: ev.target.value,
            variable_id: selectedVariable.variable_id,
            project_id: this.project.id,
            string_id: this.locale.project_locale_string_id
        });
    }

    handleDownloadPackageClick = ({format}) => {
        let action=translationsAPI.buildTranslationsDownloadPackageUrl({project_id: this.props.project.id, format: format});
        const auth_token = this.props.loginData.token;
        let x = "<form class='tmpform' action='"+action+"' method='POST'><input type='hidden' name='auth_token' value='"+auth_token+"' /><input type='submit' /></form>";
        var div = document.createElement('div');
        div.innerHTML = x;
        document.body.append(div);
        div.getElementsByClassName("tmpform")[0].submit();
        setTimeout(() => {
            document.body.removeChild(div);
        }, 1000);
    }

    handleChecked = () => {
        const variables = this.getVariables();
        const variable_name = this.getSelectedVariableName();
        const selectedVariable = _.find(variables, (v)=>v.variable_name == variable_name);
        this.setState({})
        this.props.actions.translationsUpdateRequest({
            text: selectedVariable.text,
            variable_id: selectedVariable.variable_id,
            project_id: this.project.id,
            string_id: this.locale.project_locale_string_id
        });
    }

    render() {
        const {locale, project} = this.props;

        let variables = this.getVariables();
        variables = [
            ..._.sortBy(_.filter(variables, (v) => v.is_missing), ["variable_name"]),
            ..._.sortBy(_.filter(variables, (v) => v.needs_edit && !v.is_missing), ["variable_name"]),
            ..._.sortBy(_.filter(variables, (v) => !v.needs_edit && !v.is_missing), ["variable_name"]),
        ]; //_.sortBy(variables, ['is_missing','needs_edit','variable_name'])
        const title = this.getTitle();

        const selectedVariableName = this.getSelectedVariableName();
        const selectedVariable = selectedVariableName ? _.find(variables, (v)=>v.variable_name == selectedVariableName) : null;

        return (
            <div className={`translations-list-with-editor ${this.props.className ? this.props.className : ''}`}>
            <Loading finished={!this.props.translationsLoading} render={(()=>
                <div className={`translations-list-with-editor-inner`}>
                    <TitleWithIconBar
                        title={title}
                    >
                        <If condition={this.props.loginData.tenant_role=="admin"}>
                            <IconBarItem icon={<FaUpload/>} onClick={this.handleUploadLocaleMessagesClick}>
                                <FormattedMessage
                                    id="translations_list_editor.iconbar.upload_locale_messages"
                                    defaultMessage="Upload Translated Messages"
                                />
                            </IconBarItem>
                            <IconBarItem icon={<FaUpload/>} onClick={this.handleUploadDefaultMessagesClick}>
                                <FormattedMessage
                                    id="translations_list_editor.iconbar.upload_default_messages"
                                    defaultMessage="Upload Default Messages"
                                />
                            </IconBarItem>
                            <div className={"download-option-container"}>
                                <div className={"download-option-container-inner"}>
                                    <FaDownload/>
                                    <Select
                                      placeholder={<FormattedMessage id="translations_list_editor.export.select.placeholder" defaultMessage="Format" />}
                                      className={"download-option-select"}
                                      value={this.state.exportFormat}
                                      options={EXPORT_FORMAT_VALUES}
                                      onChange={(selectedOption) => this.setState({
                                        exportFormat: selectedOption ? selectedOption.value : null
                                      }, () => {
                                          if(this.state.exportFormat){
                                            this.handleDownloadPackageClick({format: this.state.exportFormat})
                                          }
                                      })}
                                    />
                                </div>
                            </div>
                        </If>
                    </TitleWithIconBar>
                    <div className="hidden">
                        <input
                            type="file"
                            ref={(el)=>{ this.el_upload_default_messages = el; }}
                            onChange={this.handleUploadDefaultMessagesFileSelected}
                            accept=".pot,.js,.json,.xlf"
                        />
                        <input
                            type="file"
                            ref={(el)=>{ this.el_upload_locale_messages = el; }}
                            onChange={this.handleUploadLocaleMessagesFileSelected}
                            accept=".po,.js,.json,.xlf"
                        />
                    </div>
                    <div className="clear"></div>
                    <div className="translation-list-with-editor-table-wrapper" ref={scrollItem => {
                        this.scrollItem = scrollItem;
                    }}>
                        <If condition={variables.length>0}>
                            <ATable className="translation-list-with-editor-table">
                                <thead>
                                <tr className="sticky">
                                    <th>
                                        <div>
                                            <FormattedMessage
                                                id="translationslistwitheditor.th.id"
                                                defaultMessage="ID"
                                            />
                                        </div>
                                    </th>
                                    <th>
                                        <div>
                                            <If condition={locale.parent_project_locale_id}>
                                                <FormattedMessage
                                                    id="translationslistwitheditor.th.fallbackMessage"
                                                    defaultMessage="Parent Text"
                                                />
                                            <Else />
                                                <FormattedMessage
                                                  id="translationslistwitheditor.th.defaultMessage"
                                                  defaultMessage="Source Code Text"
                                                />
                                            </If>
                                        </div>
                                    </th>
                                    <th>
                                        <div>
                                            <FormattedMessage
                                                id="translationslistwitheditor.th.translation"
                                                defaultMessage="Translation"
                                            />
                                        </div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <For each="item" of={variables}>
                                    <tr ref={trItem => {
                                        if(item == selectedVariable){
                                            this.selectedItem = trItem;
                                        }
                                    }} onClick={() => this.handleVariableClick(item.variable_name)} className={`translations-list-with-editor-row ${item.is_missing ? 'translations-list-with-editor-row-missing': ''} ${item.needs_edit && !item.is_missing ? 'translations-list-with-editor-row-needs-edit': ''} ${item == selectedVariable ? 'translations-list-with-editor-row-active': ''}`}>
                                        <td>
                                            <span className="title">{item.variable_name}</span>
                                        </td>
                                        <td>
                                            <span>{item.fallback_text}</span>
                                        </td>
                                        <td>
                                            <span>{item.text}</span>
                                        </td>
                                    </tr>
                                </For>
                                </tbody>
                            </ATable>
                        </If>
                    </div>
                    <div className={`translations-list-with-editor-editor`}>
                        <If condition={selectedVariable}>
                            <input className="translations-list-with-editor-editor-name" disabled={true} type="text" value={selectedVariable.variable_name} />
                            <textarea
                                className={`translations-list-with-editor-editor-src ${selectedVariable && selectedVariable.needs_edit ? 'needs-edit' : ''}`}
                                disabled={true}
                            >{selectedVariable.fallback_text}</textarea>
                            <textarea
                                className={`translations-list-with-editor-editor-target ${selectedVariable && selectedVariable.needs_edit ? 'needs-edit' : ''}`}
                                disabled={false}
                                ref={(el) => {this.el_target_textarea = el;}}
                                onChange={this.handleEditorTargetChange}
                            >{selectedVariable.text}</textarea>
                            <If condition={selectedVariable && selectedVariable.needs_edit}>
                                <FormButtons>
                                    <Button onClick={this.handleChecked}>
                                        <FormattedMessage id="translationslistwitheditor.translation.check.completed" defaultMessage="Prüfung abgeschlossen" />
                                    </Button>
                                </FormButtons>
                            </If>
                        </If>
                    </div>
                </div>
            ).bind(this)} />
            </div>
        );
    }
}


export default connect((state, props) => {
  return {
    translations: translationsStore.selectors.translationsList(state),
    translationsLoading: translationsStore.selectors.translationsLoading(state),
    loginData: authStore.selectors.loginData(state),
  }
},(dispatch, props) => {
  return {
    actions: bindActionCreators(Object.assign({}, translationsStore.actions, uiStore.actions), dispatch)
  }
})(TranslationsListWithEditor)



// WEBPACK FOOTER //
// ./src/components/views/translationsListWithEditor/TranslationsListWithEditor.js